const chartId = "chart-16"
let Chart = require('chart.js');
const errorBars = require('chartjs-plugin-error-bars');
Chart.defaults.global.defaultFontFamily = 'acumin-pro';
const colors = require('../../../colors');
const data = require('./data');
// const _groupBy = require('lodash/groupBy')
const _sortBy = require('lodash/sortBy')
const _each = require('lodash/each')

const sortedData = _sortBy(data, "LE");

let datasets = [];
let labels = [];
let obj = {
  label: 'Life Expectancy',
  data: [],
  errorBars: {},
  backgroundColor: [],
  borderColor: [],
  borderWidth: 1,
  fill: false,
  lineTension: 0,
}
let obj2 = {
  label: 'U.S. Average',
  data: [78.8],
  errorBars: {},
  backgroundColor: colors.secondary["orange"][40].rgba,
  borderColor: colors.secondary["orange"][40].rgba,
  borderWidth: 1,
  radius: 0,
  fill: false,
  lineTension: 0,
}
_each(sortedData, function(row) {
  labels.push(row.geo);
  obj.data.push({
    y: row.LE,
    geo: row.geo,
    p20: row.p20,
    p80: row.p80
  })
  obj2.data.push(78.8)
  obj.errorBars[row.geo] = {
    plus: row.p80 - row.LE,
    minus: row.LE - row.p20
  };
  if (row.geo.includes("New Orleans")) {
    obj.backgroundColor.push(colors.secondary["ochre"][100].rgba);
    obj.borderColor.push(colors.secondary["ochre"][80].rgba)
  } else{
    obj.backgroundColor.push(colors.secondary["blue"][100].rgba)
    obj.borderColor.push(colors.secondary["blue"][80].rgba)
  }
})
obj2.data.push(78.8)
datasets.push(obj)
datasets.push(obj2)

labels = [...new Set(labels)]

let ctx = document.getElementById(chartId).getContext('2d');

new Chart(ctx, {
  type: 'line',
  data: {
    labels: labels,
    datasets: datasets
  },
  plugins: [errorBars, {
    beforeDraw: function(chart) {
      var width = chart.chart.width,
        height = chart.chart.height,
        ctx = chart.chart.ctx;
      ctx.restore();
      ctx.textAlign = "right";
      ctx.textBaseline = "middle";
      ctx.fillStyle = colors.secondary["orange"][40].rgba;
      ctx.fillText("National average", width - 5, height * .495);
      ctx.fillText("life expectancy", width - 5, height * .535);
      ctx.fillStyle = colors.secondary["ochre"][80].rgba;
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.fillText("New Orleans-Metairie, LA", width * .12, height * .27);
      ctx.save();
    }
  }],
  options: {
    responsive: true,
    aspectRatio: window.innerWidth > 992 ? 16 / 9 : 1,
    onResize: function(chartObj) {
      chartObj.aspectRatio = window.innerWidth > 992 ? 16 / 9 : 1;
      chartObj.update()
    },
    legend: {
      display: false
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 0,
        bottom: 0
      }
    },
    tooltips: {
      callbacks: {
        title: function(tooltipItem, data) {
          let datasetIndex = tooltipItem[0].datasetIndex;
          let index = tooltipItem[0].index
          let dataset = data.datasets[datasetIndex];
          let item = dataset.data[index];
          return item.geo?item.geo:"U.S. Average";
        },
        label: function() {
          return false;
        },
        afterLabel: function(tooltipItem, data) {
          let datasetIndex = tooltipItem.datasetIndex;
          let index = tooltipItem.index
          let dataset = data.datasets[datasetIndex];
          let item = dataset.data[index];
          if (item.y) {
            return [
              `Life Expectancy: ${item.y} years`, 
              `20th Percentile: ${item.p20} years`, 
              `80th Percentile: ${item.p80} years`,
              `80-20 Gap: ${Math.round((item.p80-item.p20)*100)/100} years`
            ];
          } else {
            return "78.8"
          }
        },
      }
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: false,
          min: 70,
          max: 86,
        },
        scaleLabel: {
          display: true,
          labelString: 'Life Expectancy'
        }
      }],
      xAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          beginAtZero: false,
          display: false,
          padding: 25,
        },
        scaleLabel: {
          display: true,
          labelString: 'Metro areas (bars represent gap between 20th and 80th life expectancy percentiles)'
        }
      }]
    }
  }
})